(() => {
  if (!document.body.classList.contains('fere-page-index')) return;
  let scheduled = false;
  const update = () => {
    document.body.classList.toggle('fere-immersive-scrolled', window.scrollY > 24);
    scheduled = false;
  };
  window.addEventListener('scroll', () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(update);
  }, { passive: true });
  update();
})();
